import { motion } from "motion/react";
export function InsightCard({ children, delay = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{
        duration: 0.5,
        delay,
        ease: [0.22, 1, 0.36, 1],
      }}
      className="bg-black/20 rounded-xl p-6 backdrop-blur-sm"
    >
      <div className="flex items-start gap-4">
        <span className="text-[#fd5b38] text-xl mt-1">•</span>
        <p className="text-[#e5e7eb] leading-relaxed flex-1">{children}</p>
      </div>
    </motion.div>
  );
}
